import { noData } from "./ExportImgFigma";

export const NodataTable = `
    <div style="text-align: center; padding: 20px;">
    <br />
    <img src="${noData}" alt="No data" style="max-width: 150px;" />
    <br />
    <div>Không có dữ liệu</div>
    <br />
    </div>
`